import { render, staticRenderFns } from "./CardDownloadTemplate.vue?vue&type=template&id=7b28e8ff&scoped=true&"
import script from "./CardDownloadTemplate.vue?vue&type=script&lang=js&"
export * from "./CardDownloadTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b28e8ff",
  null
  
)

export default component.exports